import { graphql } from '@/gql';

graphql(`
  fragment OptionsFields on ItemOptionsType {
    id
    title
    subtitle
    max
    min
    type
    minAggregateOptionsQuantity
    maxAggregateOptionsQuantity
    selectedValues
  }
`);
